/* 文言は sections/main-cart-items.liquid が #dcw-i18n-addon に出す（言語ごと）。無ければ日本語（2026-10-06） */
function T(k, fb) {
  try { var j = JSON.parse((document.getElementById('dcw-i18n-addon') || {}).textContent || '{}'); return j[k] || fb; }
  catch (e) { return fb; }
}
/*
  単品不可のアップセル品（タグ addon-only）のカート見張り（2026-10-05）
  sections/main-cart-items.liquid が明細ごとに描くマーカーを読む
  - data-addon-orphans = 他の商品が無いのに残っている明細 → カートから外す
  - data-addon-overqty = 2個以上の明細 → 1個に戻す
  直したら再読み込みし、理由を一言出す（sessionStorage 経由。使えない環境では黙って直すだけ）
  明細の描き直し（数量変更・削除）は MutationObserver で拾う
*/
(function () {
  if (window.dcwAddonGuard) return;
  window.dcwAddonGuard = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var KEY = 'dcw-addon-guard-notice';
  var busy = false;

  function showNotice() {
    var msg = null;
    try {
      msg = sessionStorage.getItem(KEY);
      sessionStorage.removeItem(KEY);
    } catch (e) {}
    if (!msg) return;
    var host = document.querySelector('cart-items .page-width') || document.querySelector('cart-items');
    if (!host) return;
    var p = document.createElement('p');
    p.className = 'addon-guard__notice';
    p.setAttribute('role', 'status');
    p.textContent = msg;
    host.insertBefore(p, host.firstChild);
  }

  function check() {
    if (busy) return;
    var orphan = document.querySelector('[data-addon-orphans]');
    var over = orphan ? null : document.querySelector('[data-addon-overqty]');
    var el = orphan || over;
    if (!el) return;

    var keys = (el.getAttribute(orphan ? 'data-addon-orphans' : 'data-addon-overqty') || '').split(',').filter(Boolean);
    if (!keys.length) return;
    var titles = el.getAttribute('data-addon-titles') || T('this_item', 'この商品');  // dcw-i18n-ignore JSON が無いときの予備（日本語ページと同じ文言）
    var updates = {};
    keys.forEach(function (k) { updates[k] = orphan ? 0 : 1; });

    busy = true;
    fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates }),
    })
      .then(function (res) { return res.json(); })
      .then(function () {
        try {
          sessionStorage.setItem(
            KEY,
            orphan
              ? T('removed', '__TITLES__は単品ではご購入いただけないため、カートから外しました。').replace('__TITLES__', titles)  // dcw-i18n-ignore JSON が無いときの予備（日本語ページと同じ文言）
              : T('one_per_order', '__TITLES__は1回のご注文につき1点までのため、数量を1点にしました。').replace('__TITLES__', titles)  // dcw-i18n-ignore JSON が無いときの予備（日本語ページと同じ文言）
          );
        } catch (e) {}
        window.location.reload();
      })
      .catch(function () { busy = false; });
  }

  function init() {
    showNotice();
    check();
    var items = document.getElementById('main-cart-items');
    if (items && 'MutationObserver' in window) {
      new MutationObserver(check).observe(items, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
